import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import {
    BottomViewWrapper,
    CargoOperationsViewWrapper,
    OperationListViewWrapper,
    PopOutButton,
    PortalWrapper,
    RightViewWrapper,
    StowagePageWrapper,
    TankPlanViewWrapper,
    ViolationListViewWrapper,
    NoStowagePlansMessage,
} from './StowagePage.styles';
import TankPlanContainer from 'src/components/stowage/tankPlanView/TankPlanContainer';
import { useVesselStore } from 'src/context/VesselContext';
import useGetRotationV2 from 'src/api/useGetRotationV2';
import { useRotationStore } from 'src/context/RotationContext';
import OperationListContainer from 'src/components/stowage/operationListView/OperationListContainer';
import { useStowageStore } from 'src/context/StowageContext';
import { ContextMenuState, OverlayMenuState } from 'src/types/ViewModel/Vessel/TankPlan';
import UtilizationComponent from 'src/components/stowage/common/Utilization';
import useGetStowageApi from 'src/api/stowage/useGetStowageApi';
import ViolationListContainer from 'src/components/stowage/violationListView/ViolationListContainer';
import { TabButton, TabsWrapper, TabText } from 'src/styles/button.style';
import { TabsPanelHeader } from 'src/styles/panel.style';
import FillTankPanel from 'src/components/stowage/tankPlanView/popUpPanels/FillTankPanel';
import WindowComponent from 'src/components/common/window-component/WindowComponent';
import { FrValue, Resplit } from 'react-resplit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OperationListFilterBar from 'src/components/stowage/operationListView/OperationListFilterBar';
import ColumnsPanel from 'src/components/stowage/operationListView/SelectColumnsPanel';
import ShipFigurePanel from 'src/components/stowage/tankPlanView/popUpPanels/ShipFigurePanel';
import { useQueryParamsHandler } from 'odfjell-query-manager';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';
import BlockTankPanel from 'src/components/stowage/tankPlanView/popUpPanels/BlockTankPanel';
import AdjustCargoTemperaturePanel from 'src/components/stowage/tankPlanView/popUpPanels/AdjustCargoTemperaturePanel';
import ViolationListTab from 'src/components/stowage/violationListView/ViolationListTab';
import useUpdatedFilteredViolations from 'src/hooks/stowage/useUpdateFilteredViolations';
import ViolationListContextMenuWrapperComponent from 'src/components/stowage/violationListView/ViolationListContextMenuWrapper';
import useUpdateViolations from 'src/hooks/stowage/useUpdateViolations';
import useLoadBaseStowageData from 'src/hooks/stowage/useLoadBaseStowageData';
import TankCargoDetailsPanel from 'src/components/stowage/tankPlanView/popUpPanels/TankCargoDetailsPanel';
import theme from '../../theme';
import { useStowageUrlChangeHandler } from 'src/hooks/stowage/urlHandler/useStowageUrlChangeHandler';
import RightPane from 'src/components/stowage/common/RightPane';
import CargoColorPanel from 'src/components/stowage/tankPlanView/popUpPanels/CargoColorPanel';
import ChangeLogComponent from 'src/components/stowage/common/changeLog/ChangeLog';
import CargoOperationPanel from 'src/components/stowage/tankPlanView/popUpPanels/cargoOperationPanel/CargoOperationPanel';
import StowageModalComponent from 'src/components/stowage/common/stowageModal/StowageModal';
import SplitCargoOperationPanel from 'src/components/stowage/tankPlanView/popUpPanels/SplitCargoOperationPanel';
import OperationListContextMenuWrapper from 'src/components/stowage/operationListView/contextMenu/OperationListContextMenuWrapper';
import TankPlanPdfReportContainer from 'src/components/stowage/tankPlanView/TankPlanPdfReportContainer';
import useUpdateIsStowagePlanValid from 'src/hooks/stowage/useUpdateIsStowagePlanValid';
import OperationsForCargoPanel from 'src/components/stowage/tankPlanView/popUpPanels/operationsForCargo/OperationsForCargoPanel';
import { useStowageParameterPersistence } from 'src/utils/navigation/useStowageParameterPersistence';
import { STOWAGE_PARAMS } from 'src/utils/navigation/stowageNavigationConstants';

const SCREEN_LARGE_WIDTH_THRESHOLD = 3000;
const SCREEN_SMALL_WIDTH_THRESHOLD = 1280;

const StowagePage: React.FC = () => {
    const { selectedVessel } = useVesselStore();
    const { getImosRotation } = useGetRotationV2();
    const { setRotationMenuOpen, setTankPlanBottomContextMenuState, setPageHeaderContextMenuState } = useStowageStore();
    const { getStowagePlans } = useGetStowageApi();
    const { queryParamUpdate } = useQueryParamsHandler();
    const { handleStowagePlanGuidChange } = useStowageUrlChangeHandler();
    const {
        productList,
        portNameList,
        berthNameList,
        selectedStowageRotationBerthCall,
        selectedStowageRotationPortCall,
        setStowageRotationTree,
        setImosRotationPortCallList,
        setImosRotationCargoList,
    } = useRotationStore();
    const { loadBaseData } = useLoadBaseStowageData();

    const { selectedTab, setSelectedTab, setSelectedViolationListFilter, setSelectedViolationListStatusFilter, cargoDetailsInfo } =
        useStowageSelectionStore();
    const {
        setTankContextMenuState,
        activeStowagePlan,
        isFillPanelOpen,
        isCargoDetailsPanelOpen,
        isColumnsPanelOpen,
        setTankPlanWindowResized,
        isShipFigurePanelOpen,
        setOperationListContextMenuState,
        setBerthOperationListContextMenuState,
        setViolationListContextMenuState,
        isBlockTankPanelOpen,
        overlayMenuState,
        isAdjustCargoTemperaturePanelOpen,
        isShowOperationForCargoPanelOpen,
        isCargoColorPanelOpen,
        setRightViewWidth,
        rightViewWidth,
        rightViewHeight,
        tankplanViewWidth,
        setTankplanViewWidth,
        tankplanViewHeight,
        setTankplanViewHeight,
        tankPlan,
        isStowagePlanUpdated,
        isCargoOperationPanelOpen,
        isSplitCargoOperationPanelOpen,
        setOverlayMenuState,
        setIsFilterPanelOpen,
        isGeneratingTankPlanReport,
        popOutOperationList,
        setPopOutOperationList,
        setPortalRootHeight,
    } = useStowageStore();

    const [rightViewWrapperSize, setRightViewWrapperSize] = useState<any | null>(null);
    const [layoutFactor, setLayoutFactor] = useState<number | null>(5);

    const pageWrapperRef = useRef(null);

    // Add a ref to measure the portal root height
    const portalRootRef = useRef<HTMLDivElement>(null);

    useStowageParameterPersistence();

    // Set up a ResizeObserver to track height changes
    useLayoutEffect(() => {
        if (!portalRootRef.current) return;

        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const height = entry.contentRect.height;
                setPortalRootHeight(height);
            }
        });

        resizeObserver.observe(portalRootRef.current);

        // Clean up observer when component unmounts
        return () => {
            resizeObserver.disconnect();
        };
    }, [portalRootRef, portalRootRef.current]);

    // Update the height on initial render and window resize
    useEffect(() => {
        if (portalRootRef.current) {
            setPortalRootHeight(portalRootRef.current.offsetHeight);
        }
    }, [portalRootRef, portalRootRef.current]);

    useEffect(() => {
        resizeRightWrapperHeight();
        handleResizeHorizontal('5fr');
        handleResizeVertical('0.55fr');

        window.addEventListener('resize', handleResizePage);

        return () => {
            window.removeEventListener('resize', handleResizePage);
        };
    }, []);

    const [dataLoadingState, setDataLoadingState] = useState({
        baseDataLoaded: false,
        rotationAndPlansLoaded: false,
    });
    useEffect(() => {
        if (!selectedVessel) return;

        // Clear rotation data immediately when vessel changes to prevent showing previous vessel's rotation
        setStowageRotationTree(null);
        setImosRotationPortCallList(null);
        setImosRotationCargoList(null);
        setDataLoadingState({ baseDataLoaded: false, rotationAndPlansLoaded: false });

        const initializeBaseData = async () => {
            const result = await loadBaseData();
            if (result.success) {
                setDataLoadingState((prevState) => ({ ...prevState, baseDataLoaded: true }));
            } else {
                setDataLoadingState((prevState) => ({ ...prevState, baseDataLoaded: false }));
            }
        };

        initializeBaseData();
    }, [selectedVessel]);

    useEffect(() => {
        if (!selectedVessel || !productList || !portNameList || !berthNameList || !dataLoadingState.baseDataLoaded) {
            return;
        }

        const loadStowageData = async () => {
            try {
                await Promise.all([getImosRotation(selectedVessel.imoNumber), getStowagePlans(selectedVessel.imoNumber)]);

                setDataLoadingState((prevState) => ({ ...prevState, rotationAndPlansLoaded: true }));
            } catch (error) {
                console.error('Error loading IMOS data and StowagePlans:', error);
                setDataLoadingState((prevState) => ({ ...prevState, rotationAndPlansLoaded: false }));
            }
        };

        loadStowageData();
    }, [selectedVessel, productList, portNameList, berthNameList, dataLoadingState.baseDataLoaded]);

    useEffect(() => {
        if (!queryParamUpdate?.queryParamValues || !dataLoadingState.rotationAndPlansLoaded) return;

        const stowagePlanTrigger = queryParamUpdate.queryParamTrigger.find((qp) => qp.name === STOWAGE_PARAMS.STOWAGE_PLAN_GUID);
        if (stowagePlanTrigger?.newValue) {
            resetContext();
            setOverlayMenuState({ visible: false } as OverlayMenuState);
            handleStowagePlanGuidChange(stowagePlanTrigger.newValue);
        } else if (stowagePlanTrigger?.clearParam) {
            handleStowagePlanGuidChange(crypto.randomUUID());
        }
    }, [queryParamUpdate, dataLoadingState.rotationAndPlansLoaded]);

    useEffect(() => {
        if (!tankPlan) return;
        resizePageLayout();
    }, [tankPlan]);

    useUpdatedFilteredViolations();
    useUpdateViolations();
    useUpdateIsStowagePlanValid();

    const handleResizePage = () => {
        resizeRightWrapperHeight();
        resizePageLayout();
    };

    const resizeRightWrapperHeight = () => {
        const _rightWrapperHeight = (document.documentElement.offsetHeight - theme.constants.pageHeaderHeightNumber - 15).toString() + 'px';

        if (_rightWrapperHeight) {
            setRightViewWrapperSize({ height: _rightWrapperHeight });
        }
    };

    const handleClick = (event: React.MouseEvent) => {
        resetContext(event);
    };

    const resetContext = (event?: React.MouseEvent) => {
        // If there's an event, check if the click is inside any of the context menus
        if (event) {
            // Check if the click is inside any context menu using data attributes
            const isClickInsideTankContextMenu = (event.target as Element)?.closest('[data-context-menu="tank"]') !== null;
            const isClickInsideOperationListContextMenu = (event.target as Element)?.closest('[data-context-menu="operation-list"]') !== null;
            const isClickInsideBerthOperationListContextMenu =
                (event.target as Element)?.closest('[data-context-menu="berth-operation-list"]') !== null;
            const isClickInsideViolationListContextMenu = (event.target as Element)?.closest('[data-context-menu="violation-list"]') !== null;
            const isClickInsideTankPlanBottomContextMenu = (event.target as Element)?.closest('[data-context-menu="tank-plan-bottom"]') !== null;
            const isClickInsidePageHeaderContextMenu = (event.target as Element)?.closest('[data-context-menu="page-header"]') !== null;
            const isClickInsideRotationMenu = (event.target as Element)?.closest('[data-context-menu="rotation"]') !== null;
            const isClickInsideFilterPanel = (event.target as Element)?.closest('[data-context-menu="filter-panel"]') !== null;

            // Only close the menus that weren't clicked on
            if (!isClickInsideTankContextMenu) {
                setTankContextMenuState({ visible: false, cargoContents: [] } as ContextMenuState);
            }
            if (!isClickInsideOperationListContextMenu) {
                setOperationListContextMenuState({ visible: false } as ContextMenuState);
            }
            if (!isClickInsideBerthOperationListContextMenu) {
                setBerthOperationListContextMenuState({ visible: false } as ContextMenuState);
            }
            if (!isClickInsideViolationListContextMenu) {
                setViolationListContextMenuState({ visible: false } as ContextMenuState);
            }
            if (!isClickInsideTankPlanBottomContextMenu) {
                setTankPlanBottomContextMenuState({ visible: false } as ContextMenuState);
            }
            if (!isClickInsidePageHeaderContextMenu) {
                setPageHeaderContextMenuState({ visible: false } as ContextMenuState);
            }
            if (!isClickInsideRotationMenu) {
                setRotationMenuOpen(null);
            }
            if (!isClickInsideFilterPanel) {
                setIsFilterPanelOpen(false);
            }
        } else {
            // If no event is provided, close all menus (original behavior)
            setTankContextMenuState({ visible: false, cargoContents: [] } as ContextMenuState);
            setOperationListContextMenuState({ visible: false } as ContextMenuState);
            setBerthOperationListContextMenuState({ visible: false } as ContextMenuState);
            setViolationListContextMenuState({ visible: false } as ContextMenuState);
            setTankPlanBottomContextMenuState({ visible: false } as ContextMenuState);
            setPageHeaderContextMenuState({ visible: false } as ContextMenuState);
            setRotationMenuOpen(null);
            setIsFilterPanelOpen(false);
        }
    };

    const handleResizeVertical = (size: FrValue) => {
        setTankPlanWindowResized(size);
    };

    const handleResizeHorizontal = (size: FrValue | null) => {
        const _tankPlanWindowResizedStr = size.split('fr')[0];
        const factor = Number(_tankPlanWindowResizedStr);

        const _componentWidth2 = (factor / 6) * (window.innerWidth - 70);

        setLayoutFactor(factor);
        setRightViewWidth(_componentWidth2);

        const _rightWrapperHeight = document.documentElement.offsetHeight - theme.constants.pageHeaderHeightNumber - 15;

        if (window.innerWidth >= SCREEN_LARGE_WIDTH_THRESHOLD) {
            setTankplanViewWidth(_componentWidth2 / 2);
            setTankplanViewHeight(_rightWrapperHeight);
        } else {
            setTankplanViewWidth(_componentWidth2);
        }
    };

    const resizePageLayout = () => {
        const _componentWidth2 = (layoutFactor / 6) * (window.innerWidth - 70);
        const _rightWrapperHeight = document.documentElement.offsetHeight - theme.constants.pageHeaderHeightNumber - 15;

        setRightViewWidth(_componentWidth2);

        if (window.innerWidth >= SCREEN_LARGE_WIDTH_THRESHOLD) {
            setTankplanViewWidth(_componentWidth2 / 2);
            setTankplanViewHeight(_rightWrapperHeight);
        } else if (window.innerWidth >= SCREEN_SMALL_WIDTH_THRESHOLD) {
            setTankplanViewWidth(_componentWidth2);
            setTankplanViewHeight(null);
        }
    };

    const { filterCallViolations } = useUpdatedFilteredViolations();

    const onClickTab = (tab: string) => {
        setSelectedTab(tab);
        if (tab === 'Violation List') {
            setSelectedViolationListStatusFilter('All');
        }
        filterCallViolations();
        setSelectedViolationListFilter('Selected call');
    };
    return (
        dataLoadingState.baseDataLoaded && (
            <StowagePageWrapper onClick={handleClick} ref={pageWrapperRef}>
                <StowageModalComponent />
                {isGeneratingTankPlanReport && <TankPlanPdfReportContainer />}
                <Resplit.Root style={{ width: '100%', height: '100%' }} direction="horizontal">
                    <RightPane />
                    <Resplit.Splitter size="2px" order={1} className="splitter-horizontal" />
                    <Resplit.Pane
                        order={2}
                        asChild={true}
                        initialSize="5fr"
                        minSize="0.1fr"
                        style={rightViewWrapperSize}
                        onResize={handleResizeHorizontal}
                    >
                        <RightViewWrapper containerWidth={rightViewWidth} containerHeight={rightViewHeight}>
                            <Resplit.Root direction="vertical" style={{ height: '100%' }} className="resize-root-wrapper">
                                <Resplit.Pane
                                    order={0}
                                    asChild={true}
                                    initialSize="0.55fr"
                                    minSize="0.25fr"
                                    collapsedSize="0.25fr"
                                    onResize={handleResizeVertical}
                                >
                                    <TankPlanViewWrapper containerWidth={tankplanViewWidth} containerHeight={tankplanViewHeight}>
                                        <TankPlanContainer />
                                    </TankPlanViewWrapper>
                                </Resplit.Pane>
                                <Resplit.Splitter size="2px" order={1} className="splitter-vertical" />
                                <Resplit.Pane order={2} asChild={true} initialSize="0.45fr" collapsible minSize="0.05fr" collapsedSize="0.05fr">
                                    <CargoOperationsViewWrapper containerWidth={tankplanViewWidth} containerHeight={tankplanViewHeight}>
                                        <WindowComponent usePortal={popOutOperationList} onClosePortal={() => setPopOutOperationList(false)}>
                                            <PortalWrapper ref={portalRootRef}>
                                                <OperationListContextMenuWrapper />
                                                <ViolationListContextMenuWrapperComponent />
                                                <BottomViewWrapper>
                                                    <TabsPanelHeader columns={'auto auto auto'}>
                                                        <TabsWrapper>
                                                            <PopOutButton onClick={() => setPopOutOperationList(!popOutOperationList)}>
                                                                <FontAwesomeIcon
                                                                    title={popOutOperationList ? 'Close' : 'Pop Out'}
                                                                    icon={popOutOperationList ? 'compress' : 'external-link-square-alt'}
                                                                />
                                                            </PopOutButton>
                                                            <TabButton
                                                                className="tab"
                                                                isSelected={selectedTab === 'Operation List'}
                                                                onClick={() => onClickTab('Operation List')}
                                                            >
                                                                <TabText>Operation List</TabText>
                                                            </TabButton>
                                                            <TabButton
                                                                className="tab"
                                                                isSelected={selectedTab === 'Violation List'}
                                                                onClick={() => onClickTab('Violation List')}
                                                            >
                                                                <ViolationListTab />
                                                            </TabButton>
                                                        </TabsWrapper>
                                                        <div className="text-overflow">
                                                            <span>
                                                                {!selectedStowageRotationBerthCall &&
                                                                    selectedStowageRotationPortCall &&
                                                                    selectedStowageRotationPortCall?.portDisplayName}
                                                                {selectedStowageRotationBerthCall &&
                                                                    selectedStowageRotationPortCall?.portDisplayName +
                                                                        ' - ' +
                                                                        selectedStowageRotationBerthCall.berthName}
                                                            </span>
                                                        </div>
                                                        <OperationListFilterBar selectedTab={selectedTab}></OperationListFilterBar>
                                                    </TabsPanelHeader>

                                                    {/* Only show operation and violation lists when stowage plan data is available */}
                                                    {activeStowagePlan && isStowagePlanUpdated ? (
                                                        <>
                                                            <OperationListViewWrapper
                                                                className={selectedTab === 'Operation List' ? 'tab-visible' : 'tab-hidden'}
                                                            >
                                                                <OperationListContainer />
                                                            </OperationListViewWrapper>

                                                            <ViolationListViewWrapper
                                                                className={selectedTab === 'Violation List' ? 'tab-visible' : 'tab-hidden'}
                                                            >
                                                                <ViolationListContainer />
                                                            </ViolationListViewWrapper>
                                                        </>
                                                    ) : (
                                                        <NoStowagePlansMessage>No stowage plans available for this vessel</NoStowagePlansMessage>
                                                    )}
                                                </BottomViewWrapper>
                                            </PortalWrapper>
                                        </WindowComponent>
                                        {activeStowagePlan && isStowagePlanUpdated && (
                                            <>
                                                {isFillPanelOpen && (
                                                    <FillTankPanel
                                                        tank={overlayMenuState.tank}
                                                        cargoContents={overlayMenuState.cargoContents}
                                                        stowagePlanChanges={overlayMenuState.stowagePlanChanges}
                                                    />
                                                )}
                                                {isCargoDetailsPanelOpen && <TankCargoDetailsPanel cargoTankDetails={cargoDetailsInfo} />}
                                                {isColumnsPanelOpen && <ColumnsPanel />}
                                                {isShipFigurePanelOpen && <ShipFigurePanel tank={overlayMenuState.tank} />}
                                                {isBlockTankPanelOpen && <BlockTankPanel tank={overlayMenuState.tank} />}
                                                {isAdjustCargoTemperaturePanelOpen && <AdjustCargoTemperaturePanel />}
                                                {isShowOperationForCargoPanelOpen && <OperationsForCargoPanel />}
                                                {isCargoOperationPanelOpen && isCargoOperationPanelOpen.visible && (
                                                    <CargoOperationPanel cargoPanelContext={isCargoOperationPanelOpen} />
                                                )}
                                                {isCargoColorPanelOpen && <CargoColorPanel />}
                                                {isSplitCargoOperationPanelOpen && <SplitCargoOperationPanel />}
                                            </>
                                        )}
                                    </CargoOperationsViewWrapper>
                                </Resplit.Pane>
                            </Resplit.Root>
                        </RightViewWrapper>
                    </Resplit.Pane>
                </Resplit.Root>{' '}
                <ChangeLogComponent />
                {activeStowagePlan && isStowagePlanUpdated && <UtilizationComponent />}
            </StowagePageWrapper>
        )
    );
};

export default StowagePage;
